import { TextField, Typography } from '@mui/material'
import { memo } from 'react'

const TEXT_FIELD_STYLES = {
  minWidth: 80,
  maxWidth: 80,
}

const INPUT_STYLES = {
  fontSize: 24,
  padding: 0,
  height: 30,
  fontWeight: 600,
  lineHeight: 1.334,
}

interface PriceInputProps {
  value: string
  onChange: (songId: number, value: string) => void
  songId: number
  initialLoading: boolean
  currency: string
  isBlocked?: boolean
  validationError?: string
}

export const PriceInput = memo(
  ({
    value,
    onChange,
    songId,
    initialLoading,
    currency,
    isBlocked,
    validationError,
  }: PriceInputProps) => (
    <TextField
      variant="standard"
      value={value}
      disabled={initialLoading || isBlocked}
      onChange={e => onChange(songId, e.target.value)}
      error={!!validationError}
      helperText={validationError}
      slotProps={{
        input: {
          startAdornment: (
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: 24, lineHeight: 1.334 }}>
              {currency}
            </Typography>
          ),
          sx: {
            padding: 0,
            height: 32,
          },
          inputProps: {
            inputMode: 'decimal',
            pattern: '[0-9.]*',
            style: INPUT_STYLES,
          },
        },
      }}
      sx={TEXT_FIELD_STYLES}
    />
  ),
)
